export default __webpack_public_path__ + "static/media/IMG_1176-1 (2) - 900_HIMANSHU VERMA.380a9b50.jpg";